import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/OY-Belleza/OY-Belleza/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/OY-Belleza/OY-Belleza/node_modules/next/dist/client/image-component.js");
